module.exports = __webpack_public_path__ + "static/media/team-leads-icon.776a8a3d.svg";